
import { defineComponent } from 'vue'
import historyStaff from '@/components/insure-daily-ax/history-staff.vue'
import { urlTobase64, shake } from '@/utils/util'
import uploadFile from '@/components/upload-file.vue'
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus'
import { getInsureEnsurePlanApi, checkAddEnsureApi, addEnsureDailyApi } from '@/api/insure-daily-ax'
import { checkStaffInsureApi, queryListByEnterApi } from '@/api/long-insure-new'
import { checkoutIdCardNoListTwo, addListInformation } from '@/api/long-insure'
import ExcelJS from 'exceljs'
import { getCardAge, formTesting, formatter } from '@/utils/util'

export default defineComponent({
  props: ['showDrawer', 'baseInfo', 'projectId'],
  components: {
    historyStaff,
    uploadFile
  },
  data() {
    return {
      formatter,
      drawer: false,
      isAddHistoryStaff: false, // 在线选择 历史员工
      isAddHandStaff: false, // 手动添加 员工
      isImportList: false, // 导入名单 上传附件
      isChangeInsureInfo: false, // 更换加保信息
      isConfirmInfo: false, // 提交加保名单
      formSearch: {
        searchUserInfo: ''
      }, // 查询
      formHandStaff: {
        userName: '',
        idCardNo: ''
      }, // 加保
      addHandStaffRules: {
        userName: [{ required: true, message: '此项必填', trigger: 'blur' }],
        idCardNo: [{ required: true, message: '此项必填', trigger: 'blur' }]
      }, // 加保
      formChangeInsureInfo: {
        companyId: this.baseInfo.companyId,
        planCode: this.baseInfo.planCode,
        workType: this.baseInfo.workType,
        date: this.baseInfo.date
      },
      changeInsureInfoRules: {
        companyId: [{ required: true, message: '此项必填', trigger: 'blur' }],
        planCode: [{ required: true, message: '此项必填', trigger: 'blur' }],
        workType: [{ required: true, message: '此项必填', trigger: 'blur' }],
        date: [{ required: true, message: '此项必填', trigger: 'blur' }]
      },
      userList: [],
      filterList: [], //  查询过滤的数据
      checkErrorShow: false,
      enterErrorList: [],
      formErrorList: [] as { name: string; code: string }[],
      // planList: [],
      // companyList: [],
      workList: [],
      fileList: [],
      planList: [],
      companyList: [],
      workTypeList: [],
      priceValue: 12, // 预计扣除的加保金额
      Authorization: 'Bearer' + ' ' + global.token,
      uploadAction: process.env.VUE_APP_BASE_URL + '/rest/period-insur/serve-company/upload', // 上传路径
      saveParam: {},
      isFormError: false,
      valueNotEnoughShow: false,
      notEnoughData: {
        tomorrowNeedCostFee: '', // 明天扣除的
        currentBalance: '', // 账户余额
        willEnsureCostFee: '' // 这一批人预计扣除的
      },
      formHandTitle: '',
      formHandFlag: ''
    }
  },
  watch: {
    showDrawer: {
      handler(newval) {
        this.drawer = newval
        console.log(this.baseInfo, 'this.baseInfo-父组件传参 ')
        this.filterList = this.userList
      },
      immediate: true
    }
  },
  async created() {
    // 获取方案列表
    await this.getPlanList()
    let obj = this.planList.find((_) => {
      return this.baseInfo.planCode == _.planCode
    })

    // 获取派遣单位列表
    await this.getCompanyList(this.baseInfo.planCode, obj.code)

    // 获取工种列表
    let item = this.companyList.find((_) => {
      return this.baseInfo.companyId == _.value
    })
    this.workTypeList = item.occupationList.map((_) => {
      return {
        ..._,
        label: `${_.occupationName}`,
        value: _.occupationId
      }
    })
    // this.formChangeInsureInfo.companyId= this.baseInfo.companyId
    // this.formChangeInsureInfo.planCode= this.baseInfo.planCode
    // this.formChangeInsureInfo.workType= this.baseInfo.workType
    // this.formChangeInsureInfo.date= this.baseInfo.date
  },
  methods: {
    async initTableList() {
      console.log(this.formSearch)
      //   const res = await api(this.formSearch)
      // const result = await insureDispatchList({
      //   pageSize: this.pageSize,
      //   pageNum: this.pageNum,
      //   serveCompanyName: this.searchValue
      // })
      // this.total = result.totalCount
      // this.tableData = result.list
    },

    handleDisableDate(time) {
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate() + 1)
      tomorrow.setHours(0, 0, 0, 0)

      const lastAvailableDay = new Date()
      lastAvailableDay.setDate(tomorrow.getDate() + 6)
      lastAvailableDay.setHours(23, 59, 59, 999)
      return time.getTime() < tomorrow.getTime() || time.getTime() > lastAvailableDay.getTime()
    },
    // 获取方案列表
    async getPlanList() {
      const result = await getInsureEnsurePlanApi({
        platformCode: 1, // 平台来源（1:PC B端  2:微信B端
        insureType: 8 // 保险产品（2:长期保 8:安心日保）
      })
      this.planList = result.map((_) => {
        return {
          ..._,
          label: `${_.planName}`,
          value: _.planCode
        }
      })
      console.log('加保获取方案列表1111111111111111', this.planList)
    },
    // 选择方案后才可以选择派遣单位
    onPlanChange(planCode) {
      console.log(this.planList, planCode, '选择方案后')
      let obj = this.planList.find((_) => {
        return planCode == _.planCode
      })
      this.formChangeInsureInfo.companyId = ''
      this.formChangeInsureInfo.workType = ''
      this.getCompanyList(planCode, obj.code)
    },
    //  获取对应方案的 派遣单位
    async getCompanyList(planCode, code) {
      const res = await queryListByEnterApi({
        insureType: 8,
        planCode,
        insureCompany: code
      })
      this.companyList = res.map((_) => {
        return {
          ..._,
          label: `${_.serveCompanyName}`,
          value: _.serveCompanyId
        }
      })
      console.log(this.companyList, '选择方案后 获取对应方案的 派遣单位')
    },
    // 选择派遣单位后 过滤工种
    onCompanyChange(id) {
      let obj = this.companyList.find((_) => {
        return id == _.value
      })
      this.formChangeInsureInfo.workType = ''
      this.workTypeList = obj.occupationList.map((_) => {
        return {
          ..._,
          label: `${_.occupationName}`,
          value: _.occupationId
        }
      })
    },
    onSearch() {
      const keyword = this.formSearch.searchUserInfo
      if (!keyword) {
        // 如果关键词为空，显示全部数据
        this.filterList = this.userList
        return
      }
      const filterList = this.userList.filter((item) => {
        // 检查 name 或 idcard 是否包含关键词（不区分大小写）
        return item.userName.includes(keyword) || item.idCardNo.includes(keyword)
      })

      this.filterList = filterList
    },
    onReset() {
      this.formSearch.searchUserInfo = ''
      this.filterList = this.userList
    },
    onAddHandStaff() {
      this.formHandFlag = 'add'
      this.isAddHandStaff = true
      this.formHandTitle = '手动添加'
    },

    // 编辑人员信息
    async editPersonnelInfo(id: number, type: string, row: any) {
      console.log(44444, row)
      this.formHandStaff.userName = row.userName
      this.formHandStaff.idCardNo = row.idCardNo
      this.formHandFlag = 'edit'
      this.formHandTitle = '编辑人员信息'
      this.formHandHistory = id
      this.isAddHandStaff = true
    },
    // 单个删除
    async deletePersonnel(idCardNo: string) {
      ElMessageBox.confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.userList = this.userList.filter((item: { idCardNo: string }) => item.idCardNo !== idCardNo + '')
        this.filterList = this.userList
        this.$message.success('删除成功！')
      })
    },
    handleSizeChange() {
      this.pageNum = 1
      this.initTableList()
    },
    // 在线选择 接收 选中的历史员工
    emitAddStaff(val) {
      console.log('接收 选中的历史员工', val)
      let valArr = val.map((_) => {
        return {
          ..._,
          insureEndTime: this.formChangeInsureInfo.date
        }
      })
      this.userList = [...this.userList, ...valArr]

      // 去重
      for (let i = 0; i < this.userList.length; i++) {
        for (let j = i + 1; j < this.userList.length; j++) {
          if (this.userList[i].idCardNo === this.userList[j].idCardNo) {
            this.userList.splice(j, 1)
            j = j - 1
          }
        }
      }

      this.filterList = this.userList
      this.isAddHistoryStaff = false
    },
    // 确定 手动添加 前置校验
    async onSaveAddHandStaff() {
      console.log('手动添加', this.formHandStaff)
      ;(this.$refs.handStaffRef as any).validate((valid: any) => {
        if (valid) {
          this.onManualEntry()
        } else {
          return false
        }
      })
    },
    // 手动录入 身份证校验合法
    async onManualEntry() {
      let code = this.formHandStaff.idCardNo.replace(/\s*/g, '')
      code = this.formHandStaff.idCardNo.replace(/x/g, 'X')

      const age = getCardAge(code)

      if (age < 16) {
        ElMessage.error('小于16岁不可投保')
        return
      }

      const loading = await ElLoading.service({
        fullscreen: true,
        text: '姓名身份证校验中...'
      })
      const checkoutIdCardNoRes = await checkoutIdCardNoListTwo([
        {
          userName: this.formHandStaff.userName,
          idCardNo: this.formHandStaff.idCardNo
        }
      ])
      if (checkoutIdCardNoRes.code === 1) {
        ElMessage.error(checkoutIdCardNoRes.data[0].msg as string)
        await loading.close()
        return
      }

      const arr = this.userList
        .map((item: any) => {
          if (item.idCardNo === this.formHandStaff.idCardNo) {
            return item
          }
        })
        .filter((n: any) => n)

      if (arr.length > 0) {
        this.$message.error('列表中已有该人员')
        return
      }
      if (this.formHandFlag == 'add') {
        console.log(this.formHandFlag, this.userList)
        this.userList = [...this.userList, { ...this.formHandStaff, insureEndTime: this.formChangeInsureInfo.date }]
        this.filterList = this.userList
        this.onCloseAddHandStaff()
      }
      if (this.formHandFlag == 'edit') {
        const idex = this.userList.findIndex((_) => {
          return _.idCardNo == this.formHandHistory
        })
        console.log(idex)
        this.userList[idex] = {
          userName: this.formHandStaff.userName,
          idCardNo: this.formHandStaff.idCardNo,
          insureEndTime: this.formChangeInsureInfo.date
        }
        this.filterList = this.userList
        this.onCloseAddHandStaff()
      }
    },

    onCloseAddHandStaff() {
      ;(this.$refs.handStaffRef as any).resetFields()
      this.isAddHandStaff = false
    },
    // 关闭表格弹窗
    onFormError() {
      this.formErrorList = []
    },
    // 上传
    async onUpFile(file: File) {
      console.log(77777, file)
      const loading = await ElLoading.service({
        fullscreen: true,
        text: '名单信息校验中...'
      })
      let userList = [] as {
        userName: string
        idCardNo: string
        serveCompanyName: string
        occupationName: string
        joinType: number
        errMsg?: string
      }[]
      const reader = new FileReader()
      const errorList = [] as any
      reader.onload = async (e) => {
        userList = await this.getExcelData(e).catch(async (err: { message: string }) => {
          await loading.close()
          throw new Error(err.message)
        })

        this.formErrorList = this.formErrorList.filter((item) => item.name)
        const staffList = userList.map(
          (
            item: {
              idCardNo: string
              joinType: number
              serveCompanyName: string
              userName: string
            },
            index: number
          ) => {
            return {
              userName: item.userName,
              idCardNo: item.idCardNo,
              insureEndTime: this.formChangeInsureInfo.date
            }
          }
        )

        // 检查有没有重复身份证
        const verification = await checkoutIdCardNoListTwo(
          userList.map((item, index) => {
            return {
              userName: item.userName,
              idCardNo: item.idCardNo,
              index: index + 1
            }
          })
        )
        console.log(verification, '检查有没有重复身份证 ')
        // 错误时
        if (verification.data) {
          this.enterErrorList = verification.data
          this.checkErrorShow = true
        } else {
          await loading.close()
          this.userList = [...this.userList, ...staffList]
          // 去重
          for (let i = 0; i < this.userList.length; i++) {
            for (let j = i + 1; j < this.userList.length; j++) {
              if (this.userList[i].idCardNo === this.userList[j].idCardNo) {
                this.userList.splice(j, 1)
                j = j - 1
              }
            }
          }
          this.filterList = this.userList
        }
      }
      reader.readAsBinaryString(file)
      this.fileList.push({
        name: file.name
      })
    },
    async getExcelData(e) {
      return new Promise(async (resolve, reject) => {
        const workbook = new ExcelJS.Workbook()
        await workbook.xlsx.load((e.target as FileReader).result as ArrayBuffer)
        let userList: any = []
        try {
            workbook.getWorksheet(1).eachRow(async (item, index) => {
            console.log(item.getCell(1).value as any, item.getCell(2).value as any, '单个检验表格文字是否正常 🚀🚀🚀 ')
            // 单个检验表格文字是否正常
            const arrError = formTesting(item.getCell(1).value as any, item.getCell(2).value as any) as any
            console.log(arrError, 'arrError 是什么 🚀🚀🚀 ')
            if (arrError === false) {
                this.$message.error(`表格第${index}行有内容格式错误，请检查`)
                reject(false)
            }
            this.formErrorList.push(arrError)
            if (index <= 1) {
                return item
            }
            console.log(arrError.name || (item.getCell(1).value as string)?.trim?.(), arrError.code || (item.getCell(2).value as string).replace(/x/g, 'X')?.trim?.(), '数据是否正常 🚀🚀🚀 ')
            userList.push({
                userName: arrError.name || (item.getCell(1).value as string)?.trim?.(),
                idCardNo: arrError.code || (item.getCell(2).value as string).replace(/x/g, 'X')?.trim?.(),
                serveCompanyName: (item.getCell(3).value as string)?.trim?.(),
                occupationName: (item.getCell(4).value as string)?.trim?.(),
                joinType: 2
            })
            })
            resolve(userList)
        } catch (error) {
            ElMessageBox.confirm('读取表格数据失败，请检查模板格式是否正确？请重新下载模板文件进行导入', {
                title: '提示',
                type: 'warning',
                confirmButtonText: '确定',
                showCancelButton: false
            })
            console.log(1111, error);
            reject(false)
        }
      })
    },
    // 操作错误弹框。
    close() {
      this.checkErrorShow = false
      this.enterErrorList = []
    },
    // 下载模版
    downLoadTemp() {
      window.open('https://bullet001.51zidan.com/template/excel/安心日保投保人员名单模板.xlsx')
    },
    onCloseImportList() {
      this.isImportList = false
    },
    // 确定 导入名单
    async onSaveImportList() {
      console.log('导入名单')
    },
    // 取消并返回首页
    cancelBack() {
      this.$emit('closeDrawer', false)
    },
    // 更换加保信息
    // 关闭 加保信息
    onCloseInsureInfo() {
      console.log('关闭 更换加保信息')
      ;(this.$refs.changeInsureInfoRef as any).resetFields()
      this.isChangeInsureInfo = false
    },
    // 提交 更换加保信息操作
    async onSaveInsureInfo() {
      ;(this.$refs.changeInsureInfoRef as any).validate((valid: any) => {
        if (valid) {
          this.userList = this.userList.map((_) => {
            return { ..._, insureEndTime: this.formChangeInsureInfo.date }
          })
          this.filterList = this.userList
          ElMessage.success('更换加保信息操作成功')
          this.isChangeInsureInfo = false
        } else {
          return false
        }
      })
    },

    // 提交加保名单 前校验的金额
    async onConfirm() {
      if (this.userList.length < 1) {
        ElMessage.warning('请添加加保人员')
        return
      }

      let obj = this.planList.find((_) => {
        return this.formChangeInsureInfo.planCode == _.planCode
      })
      let companyObj = this.companyList.find((_) => {
        return this.formChangeInsureInfo.companyId == _.value
      })
      let occupationObj = this.workTypeList.find((_) => {
        return this.formChangeInsureInfo.workType == _.value
      })
      console.log('派遣单位name', companyObj, this.companyList, this.formChangeInsureInfo.companyId)
      console.log('工种name', occupationObj, this.workTypeList, this.formChangeInsureInfo.workType)
      const params = {
        staffList: this.userList,
        projectId: this.projectId, // 项目id
        companyPlanId: obj.companyPlanId, // 保险方案id
        serveCompanyId: this.formChangeInsureInfo.companyId, // 派遣单位id
        serveCompanyName: companyObj.label, // 派遣单位name
        occupationId: this.formChangeInsureInfo.workType, // 工种id
        occupationName: occupationObj.label, // 工种name
        insureEndDay: this.formChangeInsureInfo.date
      }

      this.saveParam = params
      const result = await checkAddEnsureApi(params)
      console.log('提交加保名单 前校验的金额 🌸 🌸 🌸', result)
      // 重复投保
      if (result.code == 501) {
        this.isConfirmInfo = false
        this.checkErrorShow = true
        this.enterErrorList = result.errorList.map((i) => {
          return {
            ...i,
            msg: '当前被保人已经在保'
          }
        })
        return
      }
      // if (result.code === 1 && result.errorList.length > 0) {
      //   this.isConfirmInfo = false
      //   this.enterErrorList = result.errorList
      //   return
      // }
      if (result.code == 502) {
        this.notEnoughData.tomorrowNeedCostFee = Number(result.tomorrowNeedCostFee).toFixed(2)
        this.notEnoughData.willEnsureCostFee = Number(result.willEnsureCostFee).toFixed(2)
        this.notEnoughData.currentBalance = Number(result.currentBalance).toFixed(2)
        this.valueNotEnoughShow = true
        // this.$message.error('余额不足')
        return
      }

      this.priceValue = Number(result.willEnsureCostFee).toFixed(2)
      this.isConfirmInfo = true
    },

    // 加保请求
    async onSaveConfirmInfo() {
      const res = await addEnsureDailyApi({ ...this.saveParam, insureStartDay: '' })
      console.log('提交加保名单', res)
      ElMessage.success('加保操作成功')
      // 加保成功  关闭个弹框
      this.isConfirmInfo = false
      this.$emit('closeDrawer', false)
    },
    // 提交加保名单
    onCloseConfirmInfo() {}
  }
})
